module.exports = __webpack_public_path__ + "img/data_moun_cs.39080069.png";